export default __webpack_public_path__ + "static/media/email-thankyou-icon.2dd079b9.png";